module.exports = __webpack_public_path__ + "6ee21848f20a36b0a3d20152b0169d19.svg";